export function resolveAdjustConfig<
  U extends { is_enabled: boolean },
  I extends { use_global: boolean; is_enabled: boolean },
>(
  userConfig: U | null | undefined,
  itemConfig: I,
): U | I | null | undefined {
  return itemConfig.use_global ? userConfig : itemConfig;
}
